import { render } from "./consumption.vue?vue&type=template&id=00528d3a&scoped=true"
import script from "./consumption.vue?vue&type=script&lang=js"
export * from "./consumption.vue?vue&type=script&lang=js"

import "./consumption.vue?vue&type=style&index=0&id=00528d3a&scoped=true&lang=css"
import "./consumption.vue?vue&type=style&index=1&id=00528d3a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00528d3a"]])

export default __exports__